import { createTheme } from '@mantine/core';

export const borders = createTheme({
  radius: {
    small: '2px',
    standard: '4px',
    large: '8px',
    xlarge: '12px',
  },
});
